var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXchain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 19C38 8.50659 29.4934 2.5255e-06 19 2.98418e-06C8.50659 3.44286e-06 -1.2892e-06 8.50659 -8.30516e-07 19C-3.71835e-07 29.4934 8.50659 38 19 38C29.4934 38 38 29.4934 38 19Z",
    fill: "url(#paint0_radial_486_4722)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19C38 8.50659 29.4934 2.5255e-06 19 2.98418e-06C8.50659 3.44286e-06 -1.2892e-06 8.50659 -8.30516e-07 19C-3.71835e-07 29.4934 8.50659 38 19 38C29.4934 38 38 29.4934 38 19Z",
    fill: "url(#paint1_linear_486_4722)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.343 21.3144C28.7415 18.3513 29.0759 14.2884 30.8244 11.9876C31.3312 11.3287 33.3517 9.58194 36.1948 10.9199C34.4362 7.18308 31.4968 4.11355 27.8562 2.18939C29.2601 3.98854 29.2888 6.24718 27.0639 8.20682C24.5316 10.4384 20.5617 11.0061 14.0087 7.21518C11.2838 5.63902 8.39842 5.07309 5.73434 5.39407C2.95706 8.10208 1.00418 11.6514 0.292969 15.6332C4.54504 10.5229 10.9814 11.4605 13.7114 14.8358C15.9633 17.6215 15.8383 22.5375 11.6724 25.9685C9.22958 28.1292 5.70223 29.006 2.41985 28.288C3.73077 30.6227 5.52147 32.6533 7.6568 34.2446C11.3767 34.6838 15.3416 32.8205 17.9128 29.6209C21.8861 24.6796 26.3595 25.6881 28.6266 28.3843C29.9409 29.9486 30.2399 32.7631 28.4137 35.5015C31.2957 33.8527 33.7047 31.4707 35.3856 28.6107C36.0022 25.2033 32.7519 23.0477 31.3447 21.3144H31.343Z",
    fill: "url(#paint2_linear_486_4722)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_486_4722",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22 24) rotate(50.3322) scale(26.6317 26.6317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#424242",
    stopOpacity: 0.505208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424242"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_4722",
    x1: 12,
    y1: -2.5,
    x2: 61,
    y2: 99.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFEFE",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFF2EC",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FFE6DB",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFDDCD",
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FFD4C1",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFCEB8",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFC8B0",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#FFC5AB",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFC3A8",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFC2A7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_4722",
    x1: 9.49902,
    y1: 4,
    x2: 28.999,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F80C7D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXchain);
export default __webpack_public_path__ + "static/media/xchain.f88c8bc1706c6340e80d90a8cc12f3e5.svg";
export { ForwardRef as ReactComponent };